<template>
  <div>
    <vue-headful title="Summary" />
    <ConfirmationSummary />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ConfirmationSummary from '@/components/ConfirmationSummary.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    ConfirmationSummary,
  },
  computed: {
    ...mapGetters('Company', [
      'getCompany',
    ]),
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentConfirmation));
  },
};
</script>
